import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { PhasesSection } from '../components/PhasesSection';
import { AgendaSection } from '../components/AgendaSection';
import { RouteMapSection } from '../components/RouteMapSection';
import { VenueMapSection } from '../components/VenueMapSection';
import { PetWallSection } from '../components/PetWallSection';
import { TicketsSection } from '../components/TicketsSection';
import { SponsorsSection } from '../components/SponsorsSection';
import { ActivitiesSection } from '../components/ActivitiesSection';
import { LocationSection } from '../components/LocationSection';
import { CauseSection } from '../components/CauseSection';
import { ContactSection } from '../components/ContactSection';
import { SponsorsBannerSection } from '../components/SponsorsBannerSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-2505" data-mp="29a51mc72icwk" />
      <ActivitiesSection data-id="element-2506" data-mp="29aoal3eqpqyg" />
      <AboutSection data-id="element-2507" data-mp="2aov4axrjf9w9" />
      <TicketsSection data-id="element-2508" data-mp="2apofcaxj4lk7" />
      <CauseSection data-id="element-2509" data-mp="2ao3lknj1h6ne" />
      <SponsorsBannerSection data-id="element-2510" data-mp="2aomu5dmsuior" />
      <SponsorsSection data-id="element-2511" data-mp="2eq8bpcaa3l5a" />
      <AgendaSection data-id="element-2512" data-mp="2eportq12imom" />
      <RouteMapSection data-id="element-2513" data-mp="2eox8bdkqwfep" />
      <VenueMapSection data-id="element-2514" data-mp="2eodofrbjbgy1" />
      <PetWallSection data-id="element-2515" data-mp="2jhgmabnchck1" />
      <LocationSection data-id="element-2516" data-mp="2jgx2sqi1qg3w" />
      <PhasesSection data-id="element-2517" data-mp="2jhqe84ry9tsd" />
      <ContactSection data-id="element-2518" data-mp="2jj9s5oq4vsqz" />
    </>;
}